/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MonitorOff = [
  ["path", { d: "M12 17v4" }],
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 1.184-1.826" }],
  ["path", { d: "m2 2 20 20" }],
  ["path", { d: "M8 21h8" }],
  ["path", { d: "M8.656 3H20a2 2 0 0 1 2 2v10a2 2 0 0 1-.293 1.042" }]
];

export { MonitorOff as default };
//# sourceMappingURL=monitor-off.js.map
